// Guard rail: paid vendor engines (Gaudio / AudioShake) spend credits on every run — always confirm explicitly.
export const paidNames = (engines, keys) => engines.filter((e) => keys.includes(e.key) && e.paid).map((e) => e.name);

export const confirmPaidRun = (engines, keys, runs = 1) => {
  const paid = paidNames(engines, keys);
  if (!paid.length) return true;
  return window.confirm(`This will spend vendor credits on: ${paid.join(", ")}${runs > 1 ? ` (× ${runs} masters)` : ""}.\n\nPaid engines are never selected automatically. Continue?`);
};

export const defaultOptions = (engine) => Object.fromEntries(Object.entries(engine.options || {}).map(([k, s]) => [k, s.default]));
